/* eslint-disable import/prefer-default-export */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import { SvgIconComponent } from '@mui/icons-material';
import { IconButton, styled } from '@mui/material';

interface Props {
  alertText: string;
  actionIcon: string;
  alertId: string
  backColor?: string;
  color?: string;
}

// Add here more icon components if required
const icons = {
  InfoTwoToneIcon,
};

export const CollapsableAlert: React.FC<Props> = ({
  alertText, alertId, actionIcon, color = '#FFF', backColor = '#536DFE',
}) => {
  const [open, setOpen] = useState(false);
  const ActionIcon: SvgIconComponent = actionIcon && icons[actionIcon];
  const StyledAlert = styled(Alert)({
    color,
    marginBottom: '16px',
    '&.MuiAlert-standard': {
      backgroundColor: backColor,
    },
  });

  useEffect(() => {
    const storedKey = localStorage.getItem(`MUI-alert:${alertId}`);
    if (storedKey) {
      setOpen(JSON.parse(storedKey).open);
    } else {
      localStorage.setItem(`MUI-alert:${alertId}`, JSON.stringify({ open: true }));
      setOpen(true);
    }
  }, []);
  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(`MUI-alert:${alertId}`, JSON.stringify({ open: false }));
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Collapse in={open}>
        <StyledAlert
          icon={<ActionIcon sx={{ color }} fontSize="inherit" />}
          action={(
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          )}
        >
          {alertText}
        </StyledAlert>
      </Collapse>
    </Box>
  );
};
